import React, {memo} from 'react';
import './Wheel.scss';

function Wheel({wheelTurnedOn, resultIndex, lastNumberIndex, spinAnimationEnd, assetsFolder, isClassicMode}) {
  const wheelImage = process.env.PUBLIC_URL + `./assets/${assetsFolder}/wc.png?${Date.now()}`;
  const wheelArrow = process.env.PUBLIC_URL + `./assets/${assetsFolder}/arrow.png?${Date.now()}`;

  const wheelVars = {
    '--selected-item': resultIndex > -1 && resultIndex != null ? resultIndex : lastNumberIndex,
  }

  const endAnimation = () => {
    spinAnimationEnd()
  }

  return <div className="wheel-container">
    <div className={`wheel ${wheelTurnedOn ? 'spinning' : 'starting-position'}`} style={wheelVars}
         onAnimationEnd={endAnimation}>
      <img src={wheelImage} alt='' className={`wheel-img ${isClassicMode ? " classic" : "dlx"}`}/>
    </div>
    <img className='wheel-arrow' src={wheelArrow} alt=''/>
  </div>
}

export default memo(Wheel);
